import { createIcon } from "@chakra-ui/react";

export const Plus = createIcon({
  displayName: "Plus",
  viewBox: "0 0 24 24",
  d: "M10.875 16.125v-3h-3A1.122 1.122 0 0 1 6.75 12c0-.623.502-1.125 1.125-1.125h3v-3c0-.623.502-1.125 1.125-1.125s1.125.502 1.125 1.125v3h3c.623 0 1.125.502 1.125 1.125s-.502 1.125-1.125 1.125h-3v3c0 .623-.502 1.125-1.125 1.125a1.122 1.122 0 0 1-1.125-1.125zM24 12c0 6.628-5.372 12-12 12S0 18.628 0 12 5.372 0 12 0s12 5.372 12 12zM12 2.25A9.749 9.749 0 0 0 2.25 12 9.749 9.749 0 0 0 12 21.75 9.749 9.749 0 0 0 21.75 12 9.749 9.749 0 0 0 12 2.25z",
  defaultProps: {
    "aria-label": "Add symbol: A plus symbol within a hollow circle"
  }
});

export default Plus;
